/**
 * View metadata, separated from the render functions.
 *
 * Overview reports how many views are still unmeasured, so it needs this list. Importing it
 * from `views.tsx` would be a cycle, because `views.tsx` imports Overview. Keeping the facts
 * here and the components there breaks it.
 *
 * `coverage` is a claim about instrumentation, not about health:
 *   real    — every reading on the view comes from a live source
 *   partial — some readings are live, others state plainly that they are not measured
 *   none    — nothing on the view is measured yet; it says which change would fix that
 */

export type Coverage = 'real' | 'partial' | 'none';

export interface ViewMeta {
  id: string;
  title: string;
  group: 'Monitor' | 'Respond & prepare' | 'Configure';
  coverage: Coverage;
}

export const VIEWS: ViewMeta[] = [
  { id: 'overview', title: 'Overview', group: 'Monitor', coverage: 'partial' },
  { id: 'traffic', title: 'Traffic & audience', group: 'Monitor', coverage: 'real' },
  { id: 'video', title: 'Video delivery', group: 'Monitor', coverage: 'partial' },
  { id: 'infra', title: 'Infrastructure', group: 'Monitor', coverage: 'real' },
  { id: 'database', title: 'Database & Redis', group: 'Monitor', coverage: 'real' },
  { id: 'jobs', title: 'Processing & jobs', group: 'Monitor', coverage: 'real' },
  { id: 'vapr', title: 'VAPR performance', group: 'Monitor', coverage: 'real' },
  { id: 'alerts', title: 'Alerts & incidents', group: 'Respond & prepare', coverage: 'real' },
  { id: 'capacity', title: 'Capacity planner', group: 'Respond & prepare', coverage: 'partial' },
  { id: 'tests', title: 'Load-test lab', group: 'Respond & prepare', coverage: 'real' },
  { id: 'costs', title: 'Costs & storage', group: 'Respond & prepare', coverage: 'partial' },
  { id: 'security', title: 'Security & recovery', group: 'Respond & prepare', coverage: 'real' },
  { id: 'runbooks', title: 'Runbooks', group: 'Respond & prepare', coverage: 'real' },
  { id: 'integrations', title: 'Integrations', group: 'Configure', coverage: 'real' },
  { id: 'notifications', title: 'My Notifications', group: 'Configure', coverage: 'real' },
  { id: 'routing', title: 'Discord routing', group: 'Configure', coverage: 'real' },
  { id: 'delivery', title: 'Delivery history', group: 'Configure', coverage: 'real' },
  { id: 'account', title: 'Account settings', group: 'Configure', coverage: 'real' },
];
